export default __webpack_public_path__ + "static/media/BecksText.99af1651.png";